import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  getIsAdopted,
  getIsOnSale,
  getIsPending,
  getSaleCount,
} from '../../../../utils/adoptables';
import AdoptableSold from '../exclusives/presets/AdoptableSold';
import AdoptableForSale from '../exclusives/presets/AdoptableForSale';

import s from './AdoptableInfo.scss';

interface Props {
  deviation: PapiDeviation;
}

const AdoptableInfo: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
}) => {
  const saleCount = getSaleCount(deviation);
  const isAdopted = getIsAdopted(deviation);
  const isOnSale = getIsOnSale(deviation);
  const isPending = getIsPending(deviation);

  if (isAdopted || (!isOnSale && !isPending && saleCount > 0)) {
    return (
      <div className={s['root']}>
        <AdoptableSold deviation={deviation} />
      </div>
    );
  }

  if (isOnSale || isPending) {
    return (
      <div className={s['root']}>
        <AdoptableForSale deviation={deviation} />
      </div>
    );
  }

  return null;
};
AdoptableInfo.displayName = 'AdoptableInfo';

export default AdoptableInfo;
